export default __webpack_public_path__ + "static/media/x900.03907541.png";